import localstorage from 'store';
import { showError } from '../../../common/A1Alert/A1Alert';
import Api from '../../../helpers/Api';

// ACTION  TYPE
export const SET_IS_SENDING = 'SET_IS_SENDING';
const setIsSending = (isSending) => ({
    type: SET_IS_SENDING,
    isSending,
});

export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
export const setSuccessMessage = (success) => ({
    type: SET_SUCCESS_MESSAGE,
    success,
});

// ACTION

export const sendMessage = (messageData) => (dispatch, getState) => {
    dispatch(setIsSending(true));

    const
        query = '/api/v1/recomende/sendRecomendation';
    const token = getState().profile.jwt;

    return Api.progressPost(dispatch, query, messageData, token)
        .then((json) => {
            if (json.status === 'success') {
                // clear browser localstorage
                localstorage.remove('recomendeFields');

                const myPromises = [
                    dispatch(setSuccessMessage(true)),
                    dispatch(setIsSending(false)),
                ];

                return Promise.all(myPromises);
            }

            dispatch(setIsSending(false));

            showError(json.message);

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            dispatch(setIsSending(false));

            showError('Problema na comunicação com servidor, por favor tente novamente em alguns instantes');

            throw `message got ${error}`;
        });
};

